import { ElibraryChartFrontend } from "@sabyr-dev/mist_elibrary/frontend";
import { AcademyOverviewSummaryTable } from "../../lib/overviewsummary";

export class AcademyChartFrontend extends ElibraryChartFrontend {
	getOverviewSummaryTable(jQuery: JQueryStatic): AcademyOverviewSummaryTable {
		return new AcademyOverviewSummaryTable(
			jQuery,
			this.productIdSerializer
		);
	}
}
